import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserAccountService {

    private apiURL = environment.appApiUrl + "user/";

    constructor(private http: HttpClient) { }

    resetPassword(keycloak_id: string | undefined) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + "reset-password", keycloak_id);
    }

    updateUserInformation(infos: any) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + "update", infos);
    }

    getUserInformations(id: string) : Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + "getUserInfo/" + id);
    }
}
